import Title from 'antd/lib/typography/Title'
import React from 'react'
import DivLayout from './DivLayout'

function SimplifiedSteps({caseStudy,children,iconsColor,showEndingIcons}) {
  return (
    <DivLayout divClass='position-relative' iconsColor={iconsColor} showEndingIcons={showEndingIcons}>
        <Title className='text-center layout-heading' style={{marginBottom:"5%"}}>{caseStudy?'Approach that Achieved Success':'Simplified Steps to get you Started '}</Title>
        <div className={`${caseStudy?'case_simplified_divs_data':'simplified_divs_data'}`}>
            {children}
        </div>
    </DivLayout>
  )
}

export default SimplifiedSteps